import { render, staticRenderFns } from "./logistics-information-list.vue?vue&type=template&id=3515f3bd"
import script from "./logistics-information-list.vue?vue&type=script&lang=js"
export * from "./logistics-information-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3515f3bd')) {
      api.createRecord('3515f3bd', component.options)
    } else {
      api.reload('3515f3bd', component.options)
    }
    module.hot.accept("./logistics-information-list.vue?vue&type=template&id=3515f3bd", function () {
      api.rerender('3515f3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/logistics-information/logistics-information-list.vue"
export default component.exports